import React, { useState } from "react";
import { Typography, Button } from "@material-ui/core";
import ValidatedField from "../../Helpers/FieldValidator/ValidatedField";
import { renderCheckbox } from "../../ReduxFormAdapters";

const TenantPropertyFilters = () => {
    const [expanded, setExpanded] = useState(false);

    return (
        <div style={{ padding: '0.25rem 2rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '1rem', flexWrap: 'wrap' }}>
            <Typography variant="body2" color="secondary" style={{ fontWeight: 600 }}>
                Property Types:
            </Typography>
            <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
                <ValidatedField
                    component={renderCheckbox}
                    color="primary"
                    name="residenceType.GARAGE"
                    label="Garage"
                />
                <ValidatedField
                    component={renderCheckbox}
                    color="primary"
                    name="residenceType.OFFICE"
                    label="Office"
                />
                
                {expanded && (
                    <>
                        <ValidatedField
                            component={renderCheckbox}
                            color="primary"
                            name="residenceType.ATELIER"
                            label="Atelier"
                        />
                        <ValidatedField
                            component={renderCheckbox}
                            color="primary"
                            name="residenceType.SEWING_WORKSHOP"
                            label="Sewing workshop"
                        />
                        <ValidatedField
                            component={renderCheckbox}
                            color="primary"
                            name="residenceType.CAR_WORKSHOP"
                            label="Car workshop"
                        />
                        <ValidatedField
                            component={renderCheckbox}
                            color="primary"
                            name="residenceType.MASSAGE_WORKSHOP"
                            label="Massage workshop"
                        />
                        <ValidatedField
                            component={renderCheckbox}
                            color="primary"
                            name="residenceType.PRODUCTION_HALL"
                            label="Production hall"
                        />
                    </>
                )}
                <Button 
                    color="primary" 
                    variant="text" 
                    onClick={() => setExpanded(!expanded)}
                    style={{ textTransform: 'none', fontWeight: 'bold' }}
                >
                    {expanded ? 'Show less' : 'Show more'}
                </Button>
            </div>
        </div>
    );
};

export default TenantPropertyFilters;
